/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/categorize.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Groups text messages into categories of similarly formatted text values.',
  examples: [
    'FROM sample_data\n| STATS count=COUNT() BY category=CATEGORIZE(message)',
    'FROM sample_data\n| STATS count = COUNT(*) BY category = CATEGORIZE(message), time_bucket = BUCKET(@timestamp, 1 HOUR)\n| SORT time_bucket DESC, count DESC, category',
    'FROM sample_data\n| STATS sample_message = SAMPLE(message, 1) BY category = CATEGORIZE(message)\n| SORT category',
  ],
  params: {
    field: 'Expression to categorize',
  },
};

export default docs;
